import Axios from 'axios';

import { Message } from 'view-design';
import router from '@/routers';
import store from "@/store/index.js";
const tip = msg => {
  console.error(msg);
};

const toLogin = () => {
  location.href = `/login?history=${encodeURIComponent(location.pathname)}`;
};

const modalQueueMap = new Map();
//不需要加载效果的
const noLoading = [
 '/messages/?type=1',
 '/messages/?type=2',
 '/messages/',
];
//接口返回正常,状态异常
const codeErrorHandle = resData => {
  let message = resData.msg;
  switch (resData.code) {
    case 1:
      message = message || '操作失败';
      break;
    case 500:
      message = message || '服务异常';
      router.push({ name: 'error_500' });
      break;
    //error.message = `连接出错(${error.response.status})!`;
    default:
    //token过期
    // case 403:
    //   message = '登录过期, 请重新登录';
    //   break;
    // case 406:
    //   message = '对不起，暂无业主房源';
    //   break;
    //console.log('default:', resData);
  }

  //存在对应状态码
  if (modalQueueMap.has(resData.code)) return;

  //不存在对应状态码
  modalQueueMap.set(resData.code, {
    code: resData.code,
    message: message
  });

  if (resData.code === 406) {
    console.warn(message);
    //modalQueueMap.delete(resData.code);
  } else {
    console.error(message);
    modalQueueMap.delete(resData.code);
  }
};

//请求失败后的错误统一处理
const netErrorHandle = (status, other) => {
  switch (status) {
    //未登录，去登录
    case 401:
      console.log('登录失效了');
      toLogin();
      break;
    case 403:
      tip('登录过期, 请重新登录');
      console.log('登录失效了');
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    case 404:
      tip('请求不存在!');
      break;
    default:
      console.log(other);
  }
};

//创建axios实例
const instance = Axios.create({ timeout: 25000 }); // TODO 5s测试环境容易炸了

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    let isNoLoading = false;
    for (let k in noLoading) {
      if (config.url.search(noLoading[k]) !== -1) {
        isNoLoading = true;

      }
    }
    if (isNoLoading===true){
      store.dispatch('hideLoading');
    }else {
      store.dispatch('showLoading');
    }
    let token = ''; //获取token
    token && (config.headers.Authorization = token);
    config.withCredentials = true;
    return config;
  },
  error =>{
    store.dispatch('hideLoading');
    Promise.reject(error)
  }
);


/**
 * 响应拦截器
 * 拦截响应并统一处理
 */

instance.interceptors.response.use(
  res => {
    store.commit("hideLoading");
    if (res.status && +res.status < 300 && res.data && +res.data.code === 1) {
      return Promise.resolve(res.data.data);
    } else {
      codeErrorHandle(res.data);
      if (res.data) Message.error(res.data.msg || '未知错误');
      return Promise.reject(res);
    }
  },
  error => {
    store.commit("hideLoading");
    const { response } = error;
    if (response) {
      netErrorHandle(response.status, response.data.msg);
      return Promise.reject(response);
    } else {
      //断网情况处理
      if (!window.navigator.onLine) {
        // router.push({ name: 'noNetwork'})
        return Promise.reject({ msg: '网络异常' });
        //通知断网
      } else {
        // router.push({
        //     name:'404'
        //   })
        return Promise.reject(error);
      }
    }
  }
);

export default instance;
